// src/components/CounselorCard/CounselorCard.jsx
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  ButtonBase,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../helper/urls";

const CounselorCard = ({ counselors = [] }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        /* === responsive grid === */
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr", // 1 column on extra‑small screens
          sm: "repeat(2, 1fr)", // 2 columns ≥600 px
          md: "repeat(3, 1fr)", // 3 columns ≥900 px
        },
        gap: 2,
        p: 2,
      }}
    >
      {counselors.map((counselor, index) => (
        <ButtonBase
          key={index}
          onClick={() =>
            navigate(`/student-counselor/${counselor.id}`, {
              state: { counselor },
            })
          }
          sx={{ textAlign: "left", borderRadius: 4 }}
        >
          <Card
            sx={{
              width: "100%",
              height: 150,
              display: "flex",
              borderRadius: 4,
              boxShadow: 3,
              overflow: "hidden",
            }}
          >
            {/* Avatar */}
            <Box
              sx={{
                width: 90,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                src={
                  counselor.profileImage
                    ? `${baseUrl}${counselor.profileImage}`
                    : ""
                }
                alt={counselor.firstName}
                sx={{
                  width: 80,
                  height: 80,
                  ...(counselor.profileImage
                    ? { border: "2px solid #124178", bgcolor: "#ffffff" }
                    : { bgcolor: "#124178" }),
                  fontSize: 20,
                }}
              >
                {!counselor.profileImage &&
                  counselor.firstName?.[0]?.toUpperCase()}
                {!counselor.profileImage &&
                  counselor.lastName?.[0]?.toUpperCase()}
              </Avatar>
            </Box>

            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

            {/* Content */}
            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="body1" fontWeight="bold">
                  {`${counselor.firstName?.toUpperCase() || ""} ${
                    counselor.lastName?.toUpperCase() || ""
                  }`}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  mt={1}
                  fontSize={12}
                >
                  {counselor.testimony?.slice(0, 50) + "..." || ""}
                </Typography>
              </Box>

              <Box sx={{ mt: 0, textAlign: "right" }}>
                <Typography
                  variant="body2"
                  color="primary"
                  sx={{ fontWeight: 500 }}
                >
                  View Profile →
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </ButtonBase>
      ))}
    </Box>
  );
};

export default CounselorCard;

// // src/components/CounselorCard/CounselorCard.jsx
// import React from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Avatar,
//   ButtonBase,
//   Divider,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { baseUrl } from "../../helper/urls";

// const CounselorCard = ({ counselors = [] }) => {
//   const navigate = useNavigate();

//   return (
//     <Box
//       sx={{
//         /* === THREE‑COLUMN GRID === */
//         display: "grid",
//         gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
//         gap: 2,
//         p: 2,

//         /* OPTIONAL: comment the next line out if you do NOT want horizontal scrolling on very small screens */
//         // overflowX: "auto",
//       }}
//     >
//       {counselors.map((counselor, index) => (
//         <ButtonBase
//           key={index}
//           onClick={() =>
//             navigate(`/student-counselor/${counselor.id}`, {
//               state: { counselor },
//             })
//           }
//           sx={{ textAlign: "left", borderRadius: 4 }}
//         >
//           <Card
//             sx={{
//               width: "100%", // full width of its grid cell
//               height: 200,
//               display: "flex",
//               borderRadius: 4,
//               boxShadow: 3,
//               overflow: "hidden",
//             }}
//           >
//             {/* Avatar section */}
//             <Box
//               sx={{
//                 width: 100,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <Avatar
//                 src={
//                   counselor.profileImage
//                     ? `${baseUrl}${counselor.profileImage}`
//                     : ""
//                 }
//                 alt={counselor.firstName}
//                 sx={{
//                   width: 80,
//                   height: 80,
//                   ...(counselor.profileImage
//                     ? { border: "2px solid #124178", bgcolor: "#ffffff" }
//                     : { bgcolor: "#124178" }),
//                   fontSize: 25,
//                 }}
//               >
//                 {!counselor.profileImage &&
//                   counselor.firstName?.[0]?.toUpperCase()}
//                 {!counselor.profileImage &&
//                   counselor.lastName?.[0]?.toUpperCase()}
//               </Avatar>
//             </Box>

//             <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

//             {/* Main content */}
//             <CardContent
//               sx={{
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Box>
//                 <Typography variant="body1" fontWeight="bold">
//                   {`${counselor.firstName?.toUpperCase() || ""} ${
//                     counselor.lastName?.toUpperCase() || ""
//                   }`}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" mt={1}>
//                   {counselor.testimony?.slice(0, 90) + "..." ||
//                     "We quickly learn to fear and thus automatically avoid potentially stressful situations..."}
//                 </Typography>
//               </Box>

//               <Box sx={{ mt: 2, textAlign: "right" }}>
//                 <Typography
//                   variant="body2"
//                   color="primary"
//                   sx={{ fontWeight: 500 }}
//                 >
//                   View Profile →
//                 </Typography>
//               </Box>
//             </CardContent>
//           </Card>
//         </ButtonBase>
//       ))}
//     </Box>
//   );
// };

// export default CounselorCard;

// import React from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Avatar,
//   ButtonBase,
//   Divider,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { baseUrl } from "../../helper/urls";

// const CounselorCard = ({ counselors }) => {
//   const navigate = useNavigate();

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "row",
//         // justifyContent: "space-around",
//         // flexDirection: "column",
//         // alignItems: "center",
//         flexWrap: "wrap",
//         // justifyContent: "flex-start",
//         gap: 2,
//         p: 2,
//       }}
//     >
//       {counselors?.map((counselor, index) => (
//         <ButtonBase
//           key={index}
//           onClick={() =>
//             navigate(`/student-counselor/${counselor.id}`, {
//               state: { counselor },
//             })
//           }
//           sx={{ borderRadius: 4, display: "block", textAlign: "left" }}
//         >
//           <Card
//             sx={{
//               display: "flex",
//               // width: 380,
//               width: 330,
//               height: 200,
//               borderRadius: 4,
//               boxShadow: 3,
//               overflow: "hidden",
//               textAlign: "left",
//             }}
//           >
//             {/* Avatar Section */}
//             <Box
//               sx={{
//                 width: 100,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 // backgroundColor: "#f5f5f5",
//               }}
//             >
//               <Avatar
//                 src={
//                   counselor.profileImage
//                     ? `${baseUrl}${counselor.profileImage}`
//                     : ""
//                 }
//                 alt={counselor.firstName}
//                 sx={{
//                   width: 80,
//                   height: 80,
//                   // Conditional styling based on profileImage availability
//                   ...(counselor.profileImage
//                     ? { border: "2px solid #124178", bgcolor: "#ffffff" } // If profileImage is available, show border and transparent background
//                     : { bgcolor: "#124178" }), // If no profileImage, show background color
//                   fontSize: 25,
//                 }}
//               >
//                 {/* Only show initials if profileImage is not available */}
//                 {!counselor.profileImage &&
//                   counselor.firstName?.[0]?.toUpperCase()}
//                 {!counselor.profileImage &&
//                   counselor.lastName?.[0]?.toUpperCase()}
//               </Avatar>
//             </Box>
//             <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
//             {/* Content */}
//             <CardContent
//               sx={{
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//               }}
//             >
//               {/* Top section */}
//               <Box>
//                 <Typography variant="body" fontWeight="bold">
//                   {`${counselor.firstName?.toUpperCase() || ""} ${
//                     counselor.lastName?.toUpperCase() || ""
//                   }`}
//                 </Typography>
//                 {/* <Typography variant="body2">
//                   {counselor.interestedIn || ""}
//                 </Typography> */}

//                 <Typography variant="body2" color="text.secondary" mt={1}>
//                   {counselor.testimony?.slice(0, 90) ||
//                     "We quickly learn to fear and thus automatically avoid potentially stressful situations..."}
//                 </Typography>
//               </Box>

//               <Box sx={{ mt: 2, textAlign: "right" }}>
//                 <Typography
//                   variant="body2"
//                   color="primary"
//                   sx={{ fontWeight: 500 }}
//                 >
//                   View Profile →
//                 </Typography>
//               </Box>
//             </CardContent>
//           </Card>
//         </ButtonBase>
//       ))}
//     </Box>
//   );
// };

// export default CounselorCard;
